import { DataType } from 'components/Table/types';

export type Site = {
  id?: number;
  name?: string;
  country?: string;
  city?: string;
  active?: boolean;
  lastActivity?: string;
  assignedBWMR?: number;
  createdAt?: string;
  updatedAt?: string;
  patientCount?: number;
  siteId?: string;
  siteManagerCount?: number;
  updatedByFirstName?: string;
  updatedByLastName?: string;
  doctorCount?: number;
  createdByLastName?: string;
  createdByFirstName?: string;
  adminCount?: number;
  activeCpCount?: number;
  cpCount?: number;
  activePatientCount?: number;
  activeDoctorCount?: number;
  activeAdminCount?: number;
  activeSiteManagerCount?: number;
};

export type SiteInputsForm = {
  name?: string;
  country?: string;
  city?: string;
  active?: boolean;
  lastActivity?: string;
  assignedBWMR?: number;
  createdAt?: string;
  updatedAt?: string;
  patientCount?: number;
  siteId?: string;
  siteManagerCount?: number;
  updatedByFirstName?: string;
  updatedByLastName?: string;
  doctorCount?: number;
  createdByLastName?: string;
  createdByFirstName?: string;
  adminCount?: number;
  activeCpCount?: number;
};

export type SiteInformationForm = Pick<Site, 'name' | 'siteId' | 'country' | 'city'>;

export const SiteId: keyof Site = 'id';
export const SiteDefaultSort: keyof Site = 'name';

export const SiteTableColumn: { [key: string]: DataType } = {
  name: 'string',
  country: 'string',
  active: 'custom',
  adminCount: 'number'
};

export const SiteTableColumnTitles = {
  name: 'Site Name',
  country: 'Country',
  active: 'Status',
  lastActivity: 'Last Activity',
  adminCount: 'Assigned BWMR'
};

export enum SiteFormFields {
  NAME = 'name',
  SITE_ID = 'siteId',
  COUNTRY = 'country',
  CITY = 'city'
}

export enum SiteFormFieldTitles {
  NAME = 'Site Name',
  SITE_ID = 'Site ID',
  COUNTRY = 'Country',
  CITY = 'City'
}
